import { ProcessStatusCode } from "@/types/code.types";

export type RegulatoryPressInfoFilterKey =
  | "allInfo"
  | "idInfo"
  | "labelIdInfo"
  | "labelNameInfo"
  | "companyInfo";

export interface RegulatoryPressInfoFilterType {
  key: RegulatoryPressInfoFilterKey;
  name: string;
  isAllInfo: boolean;
  code?: ProcessStatusCode;
}

export const REGULATORY_LIST_INFO_FILTER: RegulatoryPressInfoFilterType[] = [
  {
    key: "allInfo",
    name: "All Info",
    isAllInfo: true,
  },
  {
    key: "idInfo",
    name: "ID",
    isAllInfo: false,
  },
  {
    key: "labelIdInfo",
    name: "Label ID",
    isAllInfo: false,
  },
  {
    key: "labelNameInfo",
    name: "Label Name",
    isAllInfo: false,
  },
  {
    key: "companyInfo",
    name: "Company",
    isAllInfo: false,
  },
];

export const REGULATORY_LIST_PRESS_INFO_FILTER_KEY = [
  "allInfo",
  "idInfo",
  "labelIdInfo",
  "labelNameInfo",
  "companyInfo",
] as const;
